import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import styles from './LoadingDots.scss';

function LoadingDots(props) {
    const {
        className,
        dotClassName,
    } = props;
    const spanClassName = classNames(dotClassName, styles.loadingDots);

    return (
        <div className={classNames(className, styles.container)}>
            <span className={spanClassName} />
            <span className={spanClassName} />
            <span className={spanClassName} />
        </div>
    );
}

LoadingDots.propTypes = {
    className: PropTypes.string,
    dotClassName: PropTypes.string,
};

export default LoadingDots;
